import React, { useContext } from 'react';
import { withCampaignProvider } from 'context/CampaignContext';
import Create from './Create';
import { GET_SINGLE_CAMPAIGN } from 'Queries';
import { useQuery } from '@apollo/react-hooks';
import { Spinner } from 'components';
import useReactRouter from 'use-react-router';
import ShopContext from 'context/ShopContext';

const Update = ({ setIsOpen }) => {
    const { match } = useReactRouter();
    const { id } = match.params;
    const { data, loading, error } = useQuery(GET_SINGLE_CAMPAIGN, {
        variables: {
            id
        },
        fetchPolicy: 'no-cache'
    });
    const { state: { settings: { theme: { primary, secondary, background } } } } = useContext(
        ShopContext
    );
    if (error) throw new Error(error);
    if (loading) return <Spinner />;
    if (data) {
        if (
            data.campaign?.settings.type === 'bundles' &&
            !data.campaign?.settings.bundles.variantsPicker
        ) {
            const default_font_color = { r: 22, g: 37, b: 67, a: 1 };
            data.campaign.settings.bundles = Object.assign({}, data.campaign.settings.bundles, {
                style: 'vertical',
                labelColor: primary,
                variantsPicker: {
                    active: false,
                    label: 'Product #{{number}}',
                    confirm: 'Confirm',
                    textColor: default_font_color,
                    dropdownTextColor: primary,
                    dropdownBackground: secondary,
                    confirmTextColor: background,
                    confirmBackground: primary
                }
            });
        }
        if (
            data.campaign?.settings.type === 'bundles' &&
            !data.campaign?.settings.bundles.badge
        ) {
            data.campaign.settings.bundles = Object.assign({}, data.campaign.settings.bundles, {
                badge: {
                    text: {
                        a: 1,
                        r: 0,
                        g: 45,
                        b: 255
                    },
                    background: {
                        a: 1,
                        r: 240,
                        g: 242,
                        b: 255
                    },
                    border: {
                        a: 1,
                        r: 161,
                        g: 178,
                        b: 255
                    }
                }
            });
        }
        const UpdateCampaign = withCampaignProvider(Create, data.campaign, null, setIsOpen);
        return <UpdateCampaign />;
    }
};

export default Update;
